// agencySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL from "../../../../Constants";

// 1) Async thunk to fetch agencies
export const fetchAgencies = createAsyncThunk(
  "agency/fetchAgencies",
  async ({ page, size, query }, { rejectWithValue }) => {
    try {
      const queryString = query ? `&q=${encodeURIComponent(query)}` : "";
      const response = await fetch(
        `${API_BASE_URL}/api/inspections/agency/filtered-agencies?page=${page - 1}&size=${size}${queryString}`,
        { credentials: "include" }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json(); // e.g. { content, totalPages, number, ... }
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const initialState = {
  data: [],
  totalPages: 0,
  currentPage: 1,
  rowsPerPage: 10,
  loading: false,
  error: null,
  searchQuery: "",
};

const agencySlice = createSlice({
  name: "agency",
  initialState,
  reducers: {
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgencies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgencies.fulfilled, (state, action) => {
        const data = action.payload || {};
        state.data = Array.isArray(data.content) ? data.content : [];
        state.totalPages = data.totalPages || 0;
        // 'number' is zero-based from the server, so +1 for 1-based
        state.currentPage = (data.number ?? 0) + 1;
        state.loading = false;
      })
      .addCase(fetchAgencies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message;
      });
  },
});

export const { setRowsPerPage, setSearchQuery, setCurrentPage } =
  agencySlice.actions;

// **Selectors MUST be functions**:
export const selectAgencyData = (state) => state.agency.data;
export const selectAgencyLoading = (state) => state.agency.loading;
export const selectAgencyError = (state) => state.agency.error;
export const selectAgencyTotalPages = (state) => state.agency.totalPages;
export const selectAgencyCurrentPage = (state) => state.agency.currentPage;
export const selectAgencyRowsPerPage = (state) => state.agency.rowsPerPage;
export const selectAgencySearchQuery = (state) => state.agency.searchQuery;

export default agencySlice.reducer;
